export function stickySidebar() {
  let headerHeight = 0;
  const sidebar = $(".submit-site-sidebar");

  $(window).on("load", function() {
    headerHeight = $(".header_").outerHeight();
    if($("html").hasClass("no-dev")) {
      sidebar.stick_in_parent({
        offset_top: headerHeight
      });
    } else {
      function setPaddingTop() {
        headerHeight = $(".header_").outerHeight();
        sidebar.css("padding-top", headerHeight);
      }

      setPaddingTop();

      $(window).on("resize", function() {
        setPaddingTop();
      }); 
    }
  });
}


// WEBPACK FOOTER //
// ./assets/js/modules/stickySidebar.js